import { CDN } from 'consts';

import MarketingMedia from '../../MarketingMedia';
import { posterForVideoSource } from '../../marketing-media';

const src = `${CDN}05_data_page/01_data_header.webm`;

export default function VideoSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className="md:px-12 xl:px-20 2xl:px-40">
        <MarketingMedia
          media={{
            type: 'video',
            src,
            mimeType: 'video/webm',
            description: 'Cartwheel motion data preview.',
            poster: posterForVideoSource(src),
          }}
          className="aspect-video flex-1 md:rounded-2xl"
        />
      </div>
    </section>
  );
}
